// extracted by mini-css-extract-plugin
export default {"box":"styles_box__THeXv","boxDrop":"styles_boxDrop__YmjUm","boxDropTrash":"styles_boxDropTrash__j9wBb","boxDropComputer":"styles_boxDropComputer__juDtt"};